import { Controller, useFormContext, useWatch } from "react-hook-form";
import { View } from "react-native-ui-lib";
import {
  Label,
  Button,
  Text,
  TextField,
  Tooltip,
} from "@towersystems/roam-common-native";
import { ProductFormValues, FormInputProps } from "../../types";
import { useTranslation } from "../../../../../../utilities/i18n";

export type WeightFormInputProps = FormInputProps & {
  onSelectUomPress?: () => void;
};

export const WeightFormInput = ({ onSelectUomPress }: WeightFormInputProps) => {
  const { watch, control } = useFormContext<ProductFormValues>();
  const { t } = useTranslation("product");
  const watchedUom = watch("UOM");

  const globalDisable = useWatch({ control, name: "globalDisable" });

  const trailingMarkup = onSelectUomPress ? (
    <Tooltip text="Select Unit of Measure">
      <Button
        size="compact"
        disabled={globalDisable}
        onPress={onSelectUomPress}
      >
        <Text fontWeight="bold" color="action">
          {watchedUom}
        </Text>
      </Button>
    </Tooltip>
  ) : undefined;

  return (
    <View>
      <Label label={t("form.weight.label")}></Label>
      <Controller
        name="weight"
        control={control}
        disabled={globalDisable}
        render={({
          field: { onChange, value, onBlur, disabled },
          fieldState: { error },
        }) => (
          <TextField
            onBlur={onBlur}
            value={value ?? ""}
            keyboardType="numeric"
            readonly={disabled}
            onChangeText={onChange}
            validationMessage={error ? error.message : undefined}
            placeholder={t("form.weight.placeholder")}
            trailingAccessory={trailingMarkup}
            formatterType={error?.message ? undefined : "weight"}
          />
        )}
      />
    </View>
  );
};
